import axios from "../../http/axios";

export default {
    login(_, dados) {
        return new Promise((resolve, reject) => {
            axios.post("/loginWeentrega", dados)
                .then((response) => {
                    localStorage.setItem('weeLogged', JSON.stringify(response.data))
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    getEncomendas(_, dados) {
        return new Promise((resolve, reject) => {
            axios.post("/getEncomendas", dados)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    storeEntrega(_, dados) {
        return new Promise((resolve, reject) => {
            axios.post("/setEndereco", dados)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    consulta(_, dados) {
        return new Promise((resolve, reject) => {
            axios.post("/getEndereco", dados)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    brasilapi(_, dados) {
        return new Promise((resolve, reject) => {
            axios.get("https://brasilapi.com.br/api/cep/v1/"+ dados)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
    rastreio(_, dados) {
        return new Promise((resolve, reject) => {
            axios.post("/rastreio", dados)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

}
